// Centralized Shopify cart URLs
export const CART_URLS = {
  baseGuide: 'https://www.betterdailyguides.com/cart/51826786402606:1',
  bono1Only: 'https://www.betterdailyguides.com/cart/51831576854830:1',
  bono23Only: 'https://www.betterdailyguides.com/cart/51831583998254:1',
  allBonuses: 'https://www.betterdailyguides.com/cart/51831781327150:1',
}

export interface BumpState {
  bump1: boolean
  bump2: boolean
  upsellBump1?: boolean
  upsellBump2?: boolean
}

export function getBumps(): BumpState {
  const stored = sessionStorage.getItem('selectedBumps')
  return stored ? JSON.parse(stored) : { bump1: false, bump2: false }
}

export function saveBumps(bumps: BumpState): void {
  sessionStorage.setItem('selectedBumps', JSON.stringify(bumps))
}

export function wantsBono1(): boolean {
  const bumps = getBumps()
  return !!(bumps.bump1 || bumps.upsellBump1)
}

export function wantsBono23(): boolean {
  const bumps = getBumps()
  return !!(bumps.bump2 || bumps.upsellBump2)
}

export function buildCheckoutUrl(): string {
  const b1 = wantsBono1()
  const b23 = wantsBono23()
  if (b1 && b23) return CART_URLS.allBonuses
  if (b1) return CART_URLS.bono1Only
  if (b23) return CART_URLS.bono23Only
  return CART_URLS.baseGuide
}

export function openCheckout(): void {
  window.open(buildCheckoutUrl(), '_blank')
}
